export enum CohortExperimentPlans {
  'Studio 2' = 'studio_2',
  'Studio 5' = 'studio_5'
}
